<template>
  <div>
    <div :class="fullWidth ? 'w-full' : 'w-56'" class="relative">
      <div class="h5">
        {{ label }}
      </div>
      <button type="button" class="w-full flex justify-between items-center p-2 border-primary-medium border-2 rounded" @click="toggleSelect">
        <span v-if="returnObject" class="text-sm">{{ selected ? selected[optionTextKey] : 'Alle' }}</span>
        <span v-else class="text-sm">{{ selected ? selected : 'Alle' }}</span>
        <template v-if="filterBar">
          <font-awesome-icon v-if="selectOpen" :icon="['fas', 'caret-up']" size="sm"/>
          <font-awesome-icon v-else :icon="['fas', 'caret-down']" size="sm"/>
        </template>
        <template v-else>
          <font-awesome-icon :icon="['fas', 'sort']" size="sm" class="text-secondary-lighter"/>
        </template>
      </button>
      <transition name="slide" mode="in-out">
        <div v-if="selectOpen" class="absolute left-0 right-0 z-50">
          <div class="fixed inset-0" @click="toggleSelect"/>
          <ul class="relative bg-primary-lighter rounded -mt-1">
            <li v-if="!required" class="hover:bg-black hover:bg-opacity-10 transition duration-200 px-2 py-1" @click="selected = null">
              Alle
            </li>
            <li v-for="option in options" :key="returnObject ? option[optionTextKey] : option" class="text-sm hover:bg-black hover:bg-opacity-10 transition duration-200 px-2 py-1" @click="selected = option">
              {{ returnObject ? option[optionTextKey] : option }}
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: 'label',
    },
    required: {
      type: Boolean,
      default: false,
    },
    filterBar: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    optionTextKey: {
      type: String,
      default: 'name',
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectOpen: false,
    selected: null,
  }),
  watch: {
    selected() {
      this.$emit('input', this.selected);
      this.selectOpen = false;
    },
  },
  created() {
    if (this.required) {
      this.selected = this.options[0];
    }
  },
  methods: {
    toggleSelect() {
      this.selectOpen = !this.selectOpen;
    },
  },
};
</script>
